import ApiCommerce from '@/core/apis/ApiCommerce';
import { ICategoria } from '@/models/Entidades/ICategoria';
import { IResposta } from '@/core/models/IResposta';
import { IServicoBase } from '@/core/models/IServicoBase';
import { IRepostaConsulta } from '@/core/models/IRepostaConsulta';
import { ICategoriaParametrosConsulta } from '@/models/ParametrosRequisicao/Consulta/ICategoriaParametrosConsulta';
import { IDTOCategoria } from '@/models/DTO/IDTOCategoria';
import { IItemBuscaRapida } from '@/core/models/Consulta/IItemBuscaRapida';
import { IParametrosBuscaRapida } from '@/core/models/Consulta/IParametrosBuscaRapida';
/**
 * Serviço de Categorias
 */

class ServicoCategoria implements IServicoBase<ICategoria> {
  endPoint = 'categorias';

  apiCommerce = new ApiCommerce();

  public async incluir(categoria: ICategoria): Promise<IResposta> {
    const result: any = await this.apiCommerce.post(`${this.endPoint}`, categoria);
    return result.data;
  }

  public async atualizar(categoria: ICategoria): Promise<IResposta> {
    const result: any = await this.apiCommerce.put(`${this.endPoint}/${categoria.codigo}`, categoria);
    return result.data;
  }

  public async obter(codigo: number): Promise<ICategoria> {
    const result: any = await this.apiCommerce.get(`${this.endPoint}/${codigo}`);
    return result.data;
  }

  public async obterCategorias(parametrosConsulta: ICategoriaParametrosConsulta): Promise<IRepostaConsulta<IDTOCategoria>> {
    let parametros = '';

    if (parametrosConsulta.valorPesquisa !== undefined) {
      parametros += `?ValorPesquisa=${parametrosConsulta.valorPesquisa}`;
    }

    if (parametrosConsulta.status !== undefined) {
      parametros += (parametros !== '' ? '&' : '?');
      parametros += `Status=${parametrosConsulta.status}`;
    }

    if (parametrosConsulta.numeroPagina !== undefined && parametrosConsulta.numeroPagina > 0) {
      parametros += (parametros !== '' ? '&' : '?');
      parametros += `NumeroPagina=${parametrosConsulta.numeroPagina}`;
    }
    if (parametrosConsulta.qtdeRegistrosPagina !== undefined && parametrosConsulta.qtdeRegistrosPagina > 0) {
      parametros += (parametros !== '' ? '&' : '?');
      parametros += `QtdeRegistrosPagina=${parametrosConsulta.qtdeRegistrosPagina}`;
    }
    if (parametrosConsulta.qtdeRegistrosTotal !== undefined && parametrosConsulta.qtdeRegistrosTotal > 0) {
      parametros += (parametros !== '' ? '&' : '?');
      parametros += `QtdeRegistrosTotal=${parametrosConsulta.qtdeRegistrosTotal}`;
    }
    if (parametrosConsulta.ordenacao !== undefined) {
      parametrosConsulta.ordenacao.forEach((item) => {
        parametros += (parametros !== '' ? '&' : '?');
        parametros += `Ordenacao=${item}`;
      });
    }
    if (parametrosConsulta.codigos !== undefined) {
      parametrosConsulta.codigos.forEach((codigo) => {
        parametros += (parametros !== '' ? '&' : '?');
        parametros += `Codigos=${codigo}`;
      });
    }
    const result: any = await this.apiCommerce.get(`${this.endPoint}${parametros}`);
    return result.data;
  }

  public async buscaRapida(parametrosConsultaRapida: IParametrosBuscaRapida): Promise<IItemBuscaRapida[]> {
    const parametros = this.apiCommerce.obterParametrosBuscaRapida(parametrosConsultaRapida);
    const result: any = await this.apiCommerce.get(`${this.endPoint}/busca-rapida${parametros}`);
    return result.data;
  }

  public async deletar(codigo: number): Promise<IResposta> {
    const result: any = await this.apiCommerce.delete(`${this.endPoint}/${codigo}`);
    return result.data;
  }
}

export default ServicoCategoria;
